module.exports = __webpack_public_path__ + "img/AUT.19210d4c.png";